// Module to hold functions to assist working with welcome home images
import IsEmpty from 'lodash.isempty';
import config from 'shared/config';

// the following sizes are values congruent with the backend.
const IMAGES_SMALL = 'S';
const IMAGES_MEDIUM = 'M';
const IMAGES_LARGE = 'L';

const findMatchingImages = (images, sizePriority) => {
	if (IsEmpty(images)) {
		return [];
	}
	let matchingImages = [];
	let sizeCounter = 0;
	while (IsEmpty(matchingImages)) {
		// eslint-disable-next-line no-loop-func
		matchingImages = images.reduce((holdMatchingImages, image) => {
			if (image.size === sizePriority[sizeCounter]) {
				return holdMatchingImages.concat({ original: image.url, thumbnail: '' });
			}
			return holdMatchingImages;
		}, matchingImages);
		sizeCounter += 1;
	}

	return matchingImages;
};

/**
 * Return the best matching images based on the size ratio.
 * @param {string} images images configuration object
 * @param {enumeration} size preferred size of images
 */
const getImages = (images, size = IMAGES_LARGE) => {
	const sizePriority = [];
	switch (size) {
		case IMAGES_SMALL:
			sizePriority.push(IMAGES_SMALL, IMAGES_MEDIUM, IMAGES_LARGE);
			break;
		case IMAGES_MEDIUM:
			sizePriority.push(IMAGES_MEDIUM, IMAGES_LARGE, IMAGES_SMALL);
			break;
		default:
			sizePriority.push(IMAGES_LARGE, IMAGES_MEDIUM, IMAGES_SMALL);
			break;
	}
	const matchingImages = findMatchingImages(images, sizePriority);
	return matchingImages;
};

const getHomeImages = size => getImages(JSON.parse(config.WELCOME_IMAGES), size);

export { IMAGES_SMALL, IMAGES_MEDIUM, IMAGES_LARGE, findMatchingImages, getImages, getHomeImages };
